import React, {useEffect, useState} from 'react';
import Form from 'olive-react-myoneui/lib/Form';
import Container from 'olive-react-myoneui/lib/Container';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import FloatingLabel from 'olive-react-myoneui/lib/FloatingLabel';
import Card from 'olive-react-myoneui/lib/Card'
import { Button } from 'olive-react-myoneui';
import DropdownCommon from './student-dashboard/DropdownCommon';
import CountryPhoneCodes from '../assets/json/countryPhoneCodes.json';

function HelpForm() {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  return (
    <Row>
      <Col lg={12}>
        <div className="enquiry-content-wrapper">
          <div className="enquiry-heading-wrapper">
            <h1 className="enquiry-heading">Questions?, We are here to help!</h1>
            <p className="enquiry-desc">If you continue, You cant able to access the other parallel restricted</p>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Card className="border-0 mb-4">
              <Card.Header>
                <strong>Complete the form</strong>
              </Card.Header>
              <Card.Body>
                <FloatingLabel
                  controlId="floatingInputTitle"
                  label="Full Name*"
                  className="mb-4"
                >
                  <Form.Control type="text" placeholder="Full Name" required/>
                  <Form.Control.Feedback type="invalid">
                    Please provide your Full Name.
                  </Form.Control.Feedback>
                </FloatingLabel>
                <FloatingLabel
                  controlId="Email"
                  label="Email"
                  className="mb-4"
                >
                  <Form.Control type="email" placeholder="Email" />
                </FloatingLabel>
                <div className="custom-phone-wrap align-items-start">
                  <DropdownCommon defaultValue={CountryPhoneCodes[0]} items={CountryPhoneCodes} label={'Code'} onChange={(obj) => console.log(obj)} className="mb-0 custom-field-phonedropdown" />
                  <FloatingLabel controlId="floatingPhone" className="custom-field-phone" label="Phone Number*">
                    <Form.Control type="text" placeholder="Phone Number" required />
                    <Form.Control.Feedback type="invalid">Please provide your Phone Number.</Form.Control.Feedback>
                  </FloatingLabel>
                </div>
                <Form.Group as={Col} md="12" controlId="validationCustom02" className="mb-4">
                  <FloatingLabel controlId="floatingInput" label="UID">
                    <Form.Control required type="text" placeholder="UID" />
                    <Form.Control.Feedback type="invalid">
                      Please provide your UID.
                    </Form.Control.Feedback>
                    <Form.Text id="validationCustom01" muted>
                      Duis aute irure dolor in reprehenderit in voluptate velit.
                    </Form.Text>
                  </FloatingLabel>
                </Form.Group>
                <FloatingLabel controlId="floatingTextarea2" label="Short Description">
                  <Form.Control
                    as="textarea"
                    placeholder="Short Description"
                    style={{ height: '100px' }}
                  />
                  <p className="text-end">20/ 28 characters left</p>
                </FloatingLabel>
              </Card.Body>
              <Card.Footer className="justify-content-end">
                <Button variant="default">
                  I’ll do this later
                </Button>
                <Button variant="primary" type="submit">Submit</Button>
              </Card.Footer>
            </Card>
          </Form>
        </div>
      </Col>
    </Row>
  );
}

export default HelpForm;